import script from "./SectionQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionQuote.vue?vue&type=script&setup=true&lang=js"

import "./SectionQuote.vue?vue&type=style&index=0&id=2f92d590&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f92d590"]])

export default __exports__